import * as React from 'react'
import type {SVGProps} from 'react'
const SvgPinch = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        id="pinch_svg__Layer_1"
        x={0}
        y={0}
        viewBox="0 0 30 26"
        {...props}
    >
        <style>{'.pinch_svg__st1{fill-rule:evenodd;clip-rule:evenodd;fill:#182744}'}</style>
        <path
            id="pinch_svg__Fill-1"
            d="M12.9.5c0-.1-.1-.1-.1-.1s0-.1-.1-.1c-.1-.2-.2-.3-.5-.3H6.7c-.4 0-.7.3-.7.8s.3.8.8.8h3.7L7 5c-.3.3-.3.7 0 1 .1.1.3.2.5.2s.4 0 .5-.2l3.5-3.4v3.7c0 .4.3.8.8.8.4-.1.7-.4.7-.8V.8c0-.1 0-.2-.1-.3"
            style={{
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                fill: '#142745'
            }}
        />
        <path
            id="pinch_svg__Fill-4"
            d="M6.3 11.5H2.6L6 8c.3-.3.3-.7 0-1s-.8-.3-1 0l-3.5 3.5V6.7c0-.4-.3-.7-.7-.7s-.8.3-.8.7v5.5c0 .1 0 .2.1.3 0 .1.1.1.1.1s0 .1.1.1c.1.2.2.3.5.3h5.5c.4 0 .7-.3.7-.8s-.3-.7-.7-.7"
            className="pinch_svg__st1"
        />
        <path
            id="pinch_svg__Fill-7"
            d="M26.8 23.1c-.9.8-2.5 1.7-5.1 1.4-4.2-.5-5.4-3.5-6-5.1-.1-.2-.1-.3-.2-.4-.5-1.1-2.4-3.3-3.7-4.8l-.2-.2-.2-.2c-.2-.2-.9-.9-.9-1.4 0-.2.2-.4.5-.6.1-.1.2-.1.4-.1h.2c1.2.2 3 2.2 3.8 3.4.2.3.5.4.8.3s.5-.4.5-.7V2.4c0-.5.4-.9.9-.9h.1c.5 0 .9.4.9.9v10.7c0 .4.3.8.8.8s.7-.3.7-.8v-4c0-.5.4-.9.9-.9s.9.4.9.9v4c0 .4.3.8.8.8s.7-.3.7-.8v-2.9c0-.5.4-.9.9-.9h.1c.5 0 .9.4.9.9v2.9c0 .4.3.8.7.8s.7-.3.7-.8v-1.8c0-.5.4-.9.9-.9h.1c.5 0 .9.4.9.9v8.2c-.1 1.3-.7 2.6-1.8 3.6m.9-14.2h-.1c-.4 0-.8.1-1.1.3-.4-.8-1.2-1.4-2.1-1.4h-.1c-.4 0-.8.1-1.1.3-.4-.8-1.2-1.4-2.1-1.4H21c-.3 0-.6.1-.9.2V2.4C20 1.1 19 0 17.7 0h-.1c-1.3 0-2.3 1.1-2.3 2.4v10c-.9-1-2.2-2.1-3.4-2.4-.6-.1-1.2 0-1.7.4-.7.5-1 1.1-1.1 1.8-.1 1.2.9 2.1 1.3 2.5l.1.1s.1.1.2.3c2.5 2.8 3.3 4 3.5 4.4.1.1.1.2.2.4.6 1.6 2.2 5.4 7.2 6 .5.1.9.1 1.3.1 2.4 0 4-.9 5-1.8 1.4-1.2 2.2-3 2.2-4.7v-8.2c-.1-1.3-1.2-2.4-2.4-2.4"
            className="pinch_svg__st1"
        />
    </svg>
)
export default SvgPinch
